import { WithStyles, withStyles, Grid, Typography, Card, CardContent, Link, Button } from '@material-ui/core';
import { contentManagementAction } from '../reducers/contentMangementData';
import courseManagementServices from '../service/courseManagementServices';
import contentManagementService from '../service/courseManagementServices';
import PerfectScrollbar from 'react-perfect-scrollbar';
import MyPATDialog from '../../common/MyPATDialog';
import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import React, { Component } from 'react';
import { courseStyles } from '../styles';
import { connect } from 'react-redux';
import * as XLSX from "xlsx";
import _ from 'lodash';

interface RouteParams {
  id?: string;
  type?: string;
}
interface HoursAllocationProps extends WithStyles<typeof courseStyles>, RouteComponentProps<RouteParams> {
  viewPlanData: any,
  coursePlanResponse: any,
  isPreview: boolean,
  setRevisedHours: Function,
  setPhaseUploadFileUrl: Function
};

interface HoursAllocationState {
  subjectList: any;
  selectedSubject: string;
  phaseWiseChapterData: Array<any>;
  originalPhaseWiseChapterData: Array<any>;
  popUpState: boolean;
  selectedFile: any,
  filePreview: any,
  excelData: any,
  phaseFile: any,
  courseDetails: any
}

class HourAllocation extends Component<HoursAllocationProps, HoursAllocationState> {
  constructor(props: HoursAllocationProps) {
    super(props);
    this.state = {
      subjectList: [],
      selectedSubject: '',
      phaseWiseChapterData: [],
      originalPhaseWiseChapterData: [],
      popUpState: false,
      selectedFile: null,
      filePreview: null,
      excelData: null,
      phaseFile: null,
      courseDetails: null
    }
    this.updateAllocatedHours = this.updateAllocatedHours.bind(this);
    this.handleHoursUpdation = this.handleHoursUpdation.bind(this);
  }

  componentDidMount(): void {
    const { params: { id = '' } } = this.props.match;
    courseManagementServices.getPackageById(id).then((response: any) => {
      response &&
        response.responseObject && response.responseObject.packageData && response.responseObject.packageData.coursePlanId
      contentManagementService.getCousePlanApiById(response.responseObject.packageData.coursePlanId).then((data: any) => {
        if (Object.keys(data || {}).length) {
          this.setState({
            courseDetails: data
          }, () => {
            this.updateSubjectListing();
            this.updateChaptersData();
            this.phasePlanAvailable();
          });
        }
      })
    })
  }

  phasePlanAvailable = () => {
    const existingPhaseFile: any = {};
    (((this.state.courseDetails||{}).coursePlan || (this.state.courseDetails || {})).phases || []).forEach((phase: any) => {
      if (phase.phasePlanFileUrl) {
        const urlData = phase.phasePlanFileUrl.split('/')
        const name = urlData[urlData.length - 1];
        existingPhaseFile[phase._id] = {name};
      }
    });
    this.setState({
      phaseFile: existingPhaseFile,
    });
  }

  updateChaptersData(): void {
    let availableData: any = ((this.state.courseDetails || {}).coursePlan || this.state.courseDetails);
    const phases = JSON.parse(JSON.stringify((availableData || {}).phases || []));
    let chaptersListing: any = [];
    const phaseWiseChapterData: any = {};
    for (let phase of phases) {
      if (!phaseWiseChapterData[phase._id]) {
        phaseWiseChapterData[phase._id] = {};
      }
      for (let week of phase.weeks) {
        for (let subject of week.subjects) {
          for (let chapter of subject.chapters) {
            chapter.subjectName = subject.name;
            chapter.subjectId = subject.id;
          }
          chaptersListing = [...chaptersListing, ...subject.chapters];
        }
      }
      phaseWiseChapterData[phase._id].startDate = phase.startDate;
      phaseWiseChapterData[phase._id].endDate = phase.endDate;
      phaseWiseChapterData[phase._id].name = phase.name;
      phaseWiseChapterData[phase._id].chaptersListing = chaptersListing;
      phaseWiseChapterData[phase._id].dateToShow = this.getDateToShow(phase.startDate, phase.endDate);
      chaptersListing = [];
    }
    this.setState({
      phaseWiseChapterData: phaseWiseChapterData,
      originalPhaseWiseChapterData: phaseWiseChapterData
    });
  }

  getDateToShow(startTime: string, endTime: string) {
    const startDate = new Date(startTime);
    const endDate = new Date(endTime);
    const startDateFormat = startDate.getDate() + ' ' + startDate.toLocaleDateString('en-US', { month: 'short' });
    const endDateFormat = endDate.getDate() + ' ' + endDate.toLocaleDateString('en-US', { month: 'short' });
    return (startDateFormat + ' - ' + endDateFormat + ' ' + endDate.getFullYear());
  }

  updateSubjectListing(): void {
    const availableSubjects: any = JSON.parse(JSON.stringify(this.props.viewPlanData.subjects || []));
    if (availableSubjects.length > 1) {
      availableSubjects.unshift({ name: 'All Subjects' })
    }

    if (availableSubjects && availableSubjects.length) {
      this.setState(
        {
          subjectList: availableSubjects,
          selectedSubject: availableSubjects[0].name
        }
      )
    }
  }

  updateSubjectWiseList(selectedSubject: string): void {
    if (selectedSubject === 'All Subjects') {
      this.setState({
        phaseWiseChapterData: this.state.originalPhaseWiseChapterData,
        selectedSubject
      });
      return;
    }
    const availablePhases = JSON.parse(JSON.stringify(this.state.originalPhaseWiseChapterData || {}));
    Object.keys(availablePhases).forEach((phaseId: any) => {
      const filteredData = availablePhases[phaseId].chaptersListing.filter((chapter: any) => chapter.subjectName === selectedSubject)
      availablePhases[phaseId].chaptersListing = filteredData;
    })

    this.setState({
      phaseWiseChapterData: availablePhases,
      selectedSubject
    });
  }

  handlePopupState(state: boolean) {
    if (!state) {
      this.handleRemoveFile();
    }
    this.setState({
      popUpState: state
    });
  }

  handlePhaseUpload = (e: any, phase: any) => {
    const file = e.target.files[0];
    let contentType = file.type.split('/')[1];
    if (contentType !== 'pdf') {
      contentType = 'msword';
    }
    courseManagementServices.uploadPhasePlanOnS3({ contentType, file }).then((data: any) => {
      const url = data.split('?')[0];
      this.props.setPhaseUploadFileUrl({[phase]: {url, phase}});
      this.setState((prevState) => ({
        phaseFile: { ...prevState.phaseFile, [phase]: file },
      }));
    });
  }

  handleFileUpload = (e: any) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (event: any) => {
      const data = event.target.result;
      const workbook = XLSX.read(data, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const excelData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      this.setState({
        selectedFile: file,
        filePreview: event.target.result,
        excelData
      });
    };
    reader.readAsBinaryString(file);
  };

  handleRemoveFile = () => {
    this.setState({
      selectedFile: null,
      filePreview: null,
      excelData: null
    });
  };

  downloadExcelFile = () => {
    const jsonData: any = [];
    Object.keys(this.state.phaseWiseChapterData || {}).map((key: any) => {
      (this.state.phaseWiseChapterData[key].chaptersListing || []).forEach((item: any) => {
        jsonData.push({ 'Chapter id': item.id, 'Chapter name': item.name, Hours: item.hours })
      })
    });
    const worksheet = XLSX.utils.json_to_sheet(jsonData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, 'hoursAllocation.xlsx');
  };

  updateAllocatedHours(): void {
    const dataToUpdate = JSON.parse(JSON.stringify(this.state.phaseWiseChapterData || {}));
    this.state.excelData.forEach((data: any) => {
      Object.keys(dataToUpdate || {}).map((key: any) => {
        (dataToUpdate[key].chaptersListing || []).forEach((item: any) => {
          if (item.id === data[0]) {
            item.hours = data[2];
          }
        })
      });
    });
    this.setState({
      phaseWiseChapterData: dataToUpdate,
      originalPhaseWiseChapterData: dataToUpdate,
      popUpState: false
    });
    this.props.setRevisedHours(dataToUpdate);
    this.handleRemoveFile();
  }

  handleHoursUpdation(e: any, phase: any, chapter: any): void {
    const value = e.target.value;
    const regex = /^\d+$/;
    if (!value || regex.test(value)) {
      const dataToUpdate = JSON.parse(JSON.stringify(this.state.phaseWiseChapterData || {}));
      Object.keys(dataToUpdate || {}).map((key: any) => {
        (dataToUpdate[key].chaptersListing || []).forEach((item: any) => {
          if (item.id === chapter.id) {
            item.hours = value;
          }
        });
      });
      this.setState({
        phaseWiseChapterData: dataToUpdate,
        originalPhaseWiseChapterData: dataToUpdate
      });
      this.props.setRevisedHours(dataToUpdate);
    }
  }

  handlePhaseFileRemoval = (phase: any) => {
    this.setState((prevState) => ({
      phaseFile: { ...prevState.phaseFile, [phase]: null },
    }));
  }

  downloadPhasePlan = (e: any, phase: any) => {
    const currentPhase = (((this.state.courseDetails||{}).coursePlan || (this.state.courseDetails || {})).phases || []).find((p: any) => p._id === phase);
    window.open(currentPhase.phasePlanFileUrl, '_blank');
  }

  render() {
    const { classes } = this.props;
    return (
      <>
        <Card>
          <PerfectScrollbar>
            <CardContent style={{ padding: 0 }}>
              {
                !this.props.isPreview ? <Grid className={classes.strip}>
                  Please note, any changes made to the phase plan or chapter hours will be updated only in the current course
                </Grid> : <></>
              }
              {/* Phase with date */}
              <Grid container justify="space-between" spacing={8} className={classes.headerSection}>
                <Grid item xs={9}>
                  <Typography className={[classes.cardHeading, classes.mt_0].join(' ')}>Chapter List</Typography>
                </Grid>
                {
                  !this.props.isPreview ?
                    <Grid item xs={3} className={classes.textRight}>
                      <Link className={classes.logsCta} onClick={() => this.handlePopupState(true)}><img src="/assets/img/hour-icon.svg" alt="Logs" />Allocate hours</Link>
                    </Grid> : <></>
                }
                <div className={classes.customTabs}>
                  <div className={classes.tabBorder}>
                    <ul>
                      {
                        (this.state.subjectList || []).map((subject: any) => {
                          return <li className={this.state.selectedSubject === subject.name ? classes.activeTab : classes.subTabs}
                            key={subject.name}
                            onClick={() => this.updateSubjectWiseList(subject.name)}>{subject.name}</li>
                        })
                      }
                    </ul>
                  </div>
                </div>
              </Grid>
              {
                (Object.keys(this.state.phaseWiseChapterData) || []).map((phase: any, index: number) => {
                  return (
                    <Grid container justify="space-between" key={index}>
                      <Grid item xs={12}>
                        <Grid container justify="space-between" alignItems="center" className={classes.chapterList}>
                          <Grid item className={classes.chapterHeader}>
                            {this.state.phaseWiseChapterData[phase].name}<em className={classes.phasedate}>{this.state.phaseWiseChapterData[phase].dateToShow}</em>
                          </Grid>
                          {
                            this.props.isPreview ? (
                              ((this.state.phaseFile || {})[phase] ? <Grid item>
                                <Link className={classes.phasePlanCta} onClick={() => { this.downloadPhasePlan(event, phase) }}>View Phase plan</Link>
                              </Grid> : <></>)
                            ) : (this.state.phaseFile||{})[phase] ? (
                              <Grid item>
                                <Typography className={classes.uploadedFile}>
                                  <img src='/assets/img/pdf-file.svg' alt='PDF' />
                                    <span>{((this.state.phaseFile || {})[phase] || {}).name}</span>
                                  <img className={classes.cursorPointer} src='/assets/img/close-fill.svg' onClick={()=>this.handlePhaseFileRemoval(phase)} alt='Remove' />
                                </Typography>
                              </Grid>
                            ) : (
                              <Grid item>
                                <Typography className={classes.uploadBtn}>
                                  <label>
                                    <input type="file" accept=".pdf, .doc, .docx" onChange={() => { this.handlePhaseUpload(event, phase) }} />
                                    <img src='/assets/img/upload-icon.svg' alt='Upload' /> Upload
                                  </label>
                                </Typography>
                              </Grid>
                            )
                          }

                        </Grid>
                        {
                          (this.state.phaseWiseChapterData[phase].chaptersListing || []).map((chapter: any, chapterIdx: number) => {
                            return (
                              <Grid key={chapterIdx} container justify="space-between" alignItems="center" className={classes.chapterList}>
                                <Grid item className={classes.listItem}>
                                  CH{chapterIdx + 1}. {chapter.name} {(this.state.selectedSubject === 'All Subjects') && <span>({chapter.subjectName})</span>}
                                </Grid>
                                <Grid item className={classes.hourCount}>
                                  {
                                    this.props.isPreview ? <>{chapter.hours || 0} hours</> : <input onChange={() => {
                                      this.handleHoursUpdation(event, phase, chapter)
                                    }} type='text' placeholder='Hours' value={chapter.hours} />
                                  }
                                </Grid>
                                <Grid item>
                                  <Link className={classes.phasePlanCta}></Link>
                                </Grid>
                              </Grid>
                            )
                          })
                        }
                      </Grid>
                    </Grid>
                  )
                })
              }
            </CardContent>
          </PerfectScrollbar>
        </Card>
        {/* Hour allocation dialog */}
        <MyPATDialog
          dialogOpen={this.state.popUpState}
          dialogHeading={
            <>
              <Grid container justify="center" alignItems="center" className={classes.customHeader}>
                <Grid item className={classes.dialogTitle}>Assign Hours to Chapters</Grid>
                <Typography className={classes.dialogClose} onClick={() => this.handlePopupState(false)}><img src="/assets/img/closeIcon.svg" alt="Close" /></Typography>
              </Grid>
            </>
          }
          isCloseButtonHidden={true}
          isAlignCenter={true}
          isCustomBackground={false}
          isborderDialogAction={true}
          classes={{ root: classes.assignHours }}
          otherDialogProps={{
            fullWidth: false,
          }}
          customDialogActions={
            <>
              <Grid container justify="center" alignItems="center" className={classes.mb15}>
                <Button
                  autoFocus
                  color="primary"
                  variant='contained'
                  disabled={!this.state.selectedFile}
                  onClick={this.updateAllocatedHours}
                >
                  Update Hours
                </Button>
              </Grid>
            </>
          }
        >
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item xs={12} className={classes.customUpload}>
              {this.state.filePreview ? (
                <div>
                  <img src='/assets/svg/excelDocIcon.svg' alt="Upload" className={classes.excelIcon}/>
                  <span>{this.state.selectedFile.name}</span>
                  <Button className={classes.closeBtn} onClick={this.handleRemoveFile}><img src="/assets/img/close-fill.svg" alt="Remove"/></Button>
                </div>
              ) : (
                <div>
                  <input type='file' accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={this.handleFileUpload} />
                  <img src='/assets/img/upload-icon.svg' alt="Upload" />
                  Upload Chapter’s hour details
                </div>
              )}
            </Grid>
            <Grid item xs={12} className={classes.textRight}>
              <Link className={classes.downloadCta} onClick={this.downloadExcelFile}>
                Download List of chapters
              </Link>
            </Grid>
          </Grid>
        </MyPATDialog>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  viewPlanData: _.get(state, 'courseMangementData.contentManagementData.viewPlanData', {}),
  coursePlanResponse: state.createCoursePlanStates.coursePlanResponse,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setRevisedHours: contentManagementAction.setRevisedHours,
      setPhaseUploadFileUrl: contentManagementAction.setPhaseUploadFileUrl
    },
    dispatch
  );

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(courseStyles)(withRouter(HourAllocation)));